/**
 * 署名 URL の取得（プロバイダ共通）。
 *
 * 署名は期限つきなので、失効していたらマニフェストを再取得して URL を貼り替え、
 * 1 度だけやり直す。URL は毎回 build(manifest) で組み立て直す — 再取得後の
 * 新しい署名を確実に使うため（古い URL でリトライしても意味がない）。
 */
import type { BookManifest, ManifestSession } from '../core/manifest';

/** 署名切れとみなす HTTP ステータス。 */
export const EXPIRED_STATUSES = new Set([401, 403, 410]);

export async function signedFetch(
  session: ManifestSession,
  build: (manifest: BookManifest) => string,
  init: RequestInit,
): Promise<Response> {
  const request = (): Promise<Response> =>
    fetch(build(session.current), { credentials: 'same-origin', ...init });

  const response = await request();
  if (!EXPIRED_STATUSES.has(response.status)) return response;

  await session.refresh();
  return request();
}
